import { Capacitor } from '@capacitor/core';

export const IOS_OAUTH_KEY = '__BLISSNET_IOS_OAUTH_PENDING__';
export const IOS_OAUTH_TS_KEY = '__BLISSNET_IOS_OAUTH_TS__';
export const IOS_OAUTH_LOCK_BREADCRUMB = 'blissnet_ios_oauth_lock';
export const IOS_OAUTH_CLOSE_BLOCKED_BREADCRUMB = 'blissnet_ios_oauth_close_blocked';
export const IOS_OAUTH_LOCK_CLEARED_BREADCRUMB = 'blissnet_ios_oauth_lock_cleared';

const MAX_LOCK_MS = 25_000;

function isIOSNative(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}

function writeCrumb(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore storage failures
  }
}

export function setIOSOAuthLock(caller: string): void {
  if (!isIOSNative()) return;

  const now = Date.now();
  (window as any)[IOS_OAUTH_KEY] = true;
  (window as any)[IOS_OAUTH_TS_KEY] = now;

  writeCrumb(IOS_OAUTH_LOCK_BREADCRUMB, `${caller}:${now}`);
  console.error(`[AUTH] iOS OAuth lock SET caller=${caller}`);
}

export function clearIOSOAuthLock(reason: string): void {
  if (!isIOSNative()) return;

  (window as any)[IOS_OAUTH_KEY] = false;
  (window as any)[IOS_OAUTH_TS_KEY] = 0;

  writeCrumb(IOS_OAUTH_LOCK_CLEARED_BREADCRUMB, `${reason}:${Date.now()}`);
  console.error(`[AUTH] iOS OAuth lock CLEARED reason=${reason}`);
}

export function isIOSOAuthPending(): boolean {
  if (!isIOSNative()) return false;

  const pending = (window as any)[IOS_OAUTH_KEY] === true;
  const ts = Number((window as any)[IOS_OAUTH_TS_KEY] || 0);

  if (!pending || !ts) return false;

  const expired = Date.now() - ts > MAX_LOCK_MS;
  if (expired) {
    clearIOSOAuthLock('expired');
    return false;
  }

  return true;
}

export function blockPrematureIOSOAuthClose(caller: string): boolean {
  if (!isIOSOAuthPending()) return false;

  writeCrumb(IOS_OAUTH_CLOSE_BLOCKED_BREADCRUMB, `${caller}:${Date.now()}`);
  console.error(`[AUTH] Browser.close BLOCKED pending iOS OAuth caller=${caller}`);
  return true;
}
